import React, { useCallback, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate, useParams } from "react-router-dom"
import { getPlaylist } from "../../store/reducers/playlistReducer"
import { Centered } from "../common/centered/Centered"
import { NotFound } from "../common/notFound/NotFound"
import { PlayListSong } from "../common/playlistSong/PlaylistSong"
import styles from './Playlist.module.css'
import { PlaylistHeader } from "./PlaylistHeader"

export const Playlist = () => {
    const { artist } = useParams()
    const { playlist, isFetching } = useSelector(state => state.playlist)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const loadPlaylist = useCallback(async () => {
        try {
            await dispatch(getPlaylist(artist))
        } catch (e) {
            alert(e.code)
            navigate('/player')
        }
    }, [dispatch, artist])

    useEffect(() => {
        loadPlaylist()
    }, [loadPlaylist])

    if (!playlist && !isFetching) {
        return <Centered>
            <NotFound message='Cannot find this artist, bro...' />
        </Centered>
    }

    return <div className={styles.playlist}>
        <PlaylistHeader 
            src={playlist ? playlist[Object.keys(playlist)].art : ''}
            value={artist} />
        {isFetching ? <div>Fetching...</div> : Object.keys(playlist).map(song => <PlayListSong key={song} song={song} />
        )}
    </div>
}